import * as React from "react";
import { styled } from "@mui/system";
import MUIAutocomplete, { AutocompleteProps } from "@mui/material/Autocomplete";
import { ChipProps, ChipTypeMap } from "@mui/material/Chip";
import { ThemeProviderProps } from "@emotion/react";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

type OptionValue = any;

// export const Autocomplete: React.FC<
//   AutocompleteProps<OptionValue, boolean, boolean, boolean>
// > = styled(
//   React.forwardRef<
//     HTMLDivElement,
//     AutocompleteProps<OptionValue, boolean, boolean, boolean>
//   >((props, ref) => (
//     <MUIAutocomplete
//       ref={ref}
//       {...props}
//       popupIcon={<KeyboardArrowDownIcon />}
//       disableClearable
//       ChipProps={{
//         deleteIcon: <CloseIcon />
//       }}
//     />
//   )),
//   {
//     name: "Autocomplete",
//     slot: "Root",
//     overridesResolver: (props, styles) => []
//   }
// )<ThemeProviderProps>(({ theme }) => ({
//   width: "500px",
//   "& .MuiAutocomplete-inputRoot": {
//     backgroundColor: theme.palette.primary.inputBackgroundDefault
//     //boxShadow: "none",
//   },
//   "& .MuiOutlinedInput-root": {
//     padding: "0px 28px 0px 6px !important"
//   },
//   "& .MuiButtonBase-root.MuiChip-root": {
//     height: "24px",
//     backgroundColor: "#DEF0F7",
//     borderColor: "transparent",
//     color: "#005075",
//     fontSize: "12px",
//     borderRadius: "4px"
//   },
//   "& .MuiAutocomplete-root.Autocomplete-root.MuiAutocomplete-tag": {
//     margin: "8px !important"
//   },

//   "& .MuiButtonBase-root.MuiChip-root .MuiChip-deleteIcon": {
//     fontSize: "14px"
//   },
//   "& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiChip-deleteIcon.MuiChip-deleteIconMedium.MuiChip-deleteIconColorDefault.MuiChip-deleteIconOutlinedColorDefault.MuiSvgIcon-root":
//     {
//       color: "#005075 !important"
//     }
// }));

export const Autocomplete = styled(
  (props: AutocompleteProps<OptionValue, boolean, boolean, boolean>) => {
    return (
      <MUIAutocomplete
        {...props}
        popupIcon={<KeyboardArrowDownIcon />}
        disableClearable={props?.disableClearable ?? true}
        ChipProps={{
          deleteIcon: <CloseIcon />
        }}
      />
    );
  },
  {
    name: "Autocomplete",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)<ThemeProviderProps>(({ theme }) => ({
  width: "500px",
  "& .MuiAutocomplete-inputRoot": {
    backgroundColor: theme.palette.primary.inputBackgroundDefault
    //boxShadow: "none",
  },
  "& .MuiOutlinedInput-root": {
    padding: "0px 28px 0px 6px !important"
  },
  "& .MuiButtonBase-root.MuiChip-root": {
    height: "24px",
    backgroundColor: "#DEF0F7",
    borderColor: "transparent",
    color: "#005075",
    fontSize: "12px",
    borderRadius: "4px"
  },
  "& .MuiAutocomplete-root.Autocomplete-root.MuiAutocomplete-tag": {
    margin: "8px !important"
  },

  "& .MuiButtonBase-root.MuiChip-root .MuiChip-deleteIcon": {
    fontSize: "14px"
  },
  "& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium.MuiChip-deleteIcon.MuiChip-deleteIconMedium.MuiChip-deleteIconColorDefault.MuiChip-deleteIconOutlinedColorDefault.MuiSvgIcon-root":
    {
      color: "#005075 !important"
    }
})) as React.FC<AutocompleteProps<OptionValue, boolean, boolean, boolean>>;
